import React, { useContext } from 'react';

import { ClickAwayListener } from '@material-ui/core';
import { updateTaskDueDateAction, updateTaskOnServerAction } from 'actions/task';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DueDateField from 'screens/common/sidepanel/DetailSection/DueDateField';
import styled from 'styled-components';

import {
  getTagPageMatch,
  isDatePickerClicked,
  isObjectiveModalClicked,
  isRealignModalClicked,
  isTransientElementClicked,
  getTeamMatch,
} from 'constants/helper';
import { sendQuicklyCreatedInitiativeEvent } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import MeshListContext from '../MeshListContext';
import { ListIemUpdatingCSS, ListItemCSS } from '../styles';
import TaskEditTeamComponent from './TaskEditTeamComponent';
import TaskNameEdit from './TaskNameEdit';
import TaskObjectiveEditComponent from './TaskObjectiveEditComponent';
import TaskToIds from './TaskToIds';

function isTeamdropdownClicked(event, menuId) {
  if (!menuId) return false;
  const teamMenu = document.getElementById(`menu-${menuId}`);
  return teamMenu && teamMenu.contains(event.target);
}

function isOwnerEditClicked(event, menuId) {
  if (!menuId) return false;
  const ownerMenu = document.getElementById(`${menuId}`);
  return ownerMenu && ownerMenu.contains(event.target);
}

export default function NewTaskListItem({ task, style, onNewTaskCreate }) {
  const ownerEditPopupId = `${task.id || task.key}-card-ownerEdit`;
  const teamMenuId = `${task.id || task.key}taskTeamDropdown`;

  const history = useHistory();
  const isTeamPage = getTeamMatch(history.location.pathname);
  const isTagPage = getTagPageMatch(history.location.pathname);

  const { employee, dispatch, tasksFilters, setCreateNewInProgress } = useContext(MeshListContext);

  const { display: isRealignModalVisible } = useSelector((store) => store.realignModal);

  const { isOpen: isObjectiveCreationModalVisible } = useSelector((store) => store.objectiveCreationModal);

  const coloredDueDate = task.coloredDueDate || {};
  const handleClickOutside = (event) => {
    if (
      isObjectiveModalClicked(event) ||
      isDatePickerClicked(event) ||
      isTeamdropdownClicked(event, teamMenuId) ||
      isOwnerEditClicked(event, ownerEditPopupId) ||
      isTransientElementClicked(event) ||
      isRealignModalClicked(event) ||
      isRealignModalVisible ||
      isObjectiveCreationModalVisible
    ) {
      return;
    }
    dispatch(
      updateTaskOnServerAction({
        id: task.id,
        key: task.key,
        employeeId: employee.id,
        onNewTaskCreate,
      })
    );

    // send tracking event here. in case user click outside while editing.
    // check if this is from homepage, teamhub page or from profile page.
    if (task.editorState.getCurrentContent().hasText()) {
      sendQuicklyCreatedInitiativeEvent({
        eventProperties: {
          'Due Date': !!coloredDueDate.timeStamp,
          Parent: !!task.subObjective,
          Team: true,
        },
      });
    }

    setCreateNewInProgress(false);
  };
  return (
    <ClickAwayListener onClickAway={handleClickOutside}>
      <Container style={style}>
        <TaskNameEdit
          taskId={task.id}
          taskKey={task.key}
          editorState={task.editorState}
          dispatch={dispatch}
          employeeId={employee.id}
          onNewTaskCreate={onNewTaskCreate}
        />
        <SecondRow>
          <LeftAlignContainer>
            <DueDateField
              dueDate={coloredDueDate.timeStamp ? new Date(coloredDueDate.timeStamp) : new Date()}
              color={coloredDueDate.color}
              tooltipText={coloredDueDate.reason}
              isCrossed={coloredDueDate.isCrossed}
              detailedStatus={task.detailedStatus}
              updateDueDate={(date) =>
                dispatch(
                  updateTaskDueDateAction({
                    taskId: task.id,
                    key: task.key,
                    dueDate: date,
                    coloredDueDate: {
                      ...coloredDueDate,
                      color: date ? theme.palette.primary.main : theme.palette.grey.dark,
                      timeStamp: date ? date.getTime() : null,
                    },
                  })
                )
              }
            />
            <LeftMarginContainer>
              <TaskObjectiveEditComponent
                /* 
                  this component will only be rendered for create new task,
                  so taskId will be null for this case
                */
                taskId={null}
                dispatch={dispatch}
                taskKey={task.key}
                selectedSubObjective={task.subObjective}
              />
            </LeftMarginContainer>
            {tasksFilters.team || isTeamPage || isTagPage ? null : (
              <LeftMarginContainer>
                <TaskEditTeamComponent
                  taskId={task.id}
                  taskKey={task.key}
                  teams={employee.teams}
                  selectedTeam={employee.teams.filter((team) => team.id === task.teamId)?.[0]}
                />
              </LeftMarginContainer>
            )}
          </LeftAlignContainer>
          <TaskToIds
            taskId={task.id}
            dispatch={dispatch}
            taskKey={task.key}
            employees={task.toIds}
            isEditing={task.isEditing}
          />
        </SecondRow>
      </Container>
    </ClickAwayListener>
  );
}

const Container = styled.div`
  ${ListItemCSS};
  ${ListIemUpdatingCSS};
  background: ${(props) => props.theme.palette.background.lightBlue};
  box-shadow: ${(props) => props.theme.shadows[1]};
`;

const SecondRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
`;

const LeftAlignContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftMarginContainer = styled.div`
  margin-left: 24px;
`;
